import debug from "debug";

const log = debug("app:lids");

/**
 * Class representing the "Make Lids" feature for the application.
 * This feature is currently under development and displays a "Coming Soon" message when triggered.
 * @category Experience
 * @subcategory GeometryManagement
 */
class MakeLids {
  /**
   * Constructs the MakeLids instance.
   * @param {Object} experience - The main application experience object.
   */
  constructor(experience) {
    this.experience = experience;
    this.eventHub = experience.eventHub;
    this.comingSoon = true;

    this.setupListeners();
  }

  /**
   * Sets up event listeners for the lids feature.
   */
  setupListeners() {
    this.eventHub.on("lids-switch", this.handleLidsSwitch.bind(this));
    this.eventHub.on("destroy", this.cleanup.bind(this));
  }

  cleanup() {
    console.log(`Cleaning up MakeLids instance`);
    this.eventHub.off("destroy", this.cleanup.bind(this));

    // Remove event listeners
    this.eventHub.off("lids-switch", this.handleLidsSwitch.bind(this));

    // Reset properties
    this.comingSoon = false;

    console.log(`MakeLids cleanup completed.`);
  }

  /**
   * Handles the "lids-switch" event.
   * Displays a "Coming Soon" modal if the feature is enabled and not yet available.
   * @param {Object} event - The event object containing the state of the switch.
   * @param {boolean} event.enabled - Indicates whether the lids mode is enabled.
   */
  handleLidsSwitch(event) {
    log("event in Lids", event.enabled);

    if (this.comingSoon) {
      if (event.enabled) {
        this.eventHub.emit("modalInfo", {
          title: "Coming Soon",
          message:
            "Lids Mode is currently under development and will be available soon.",
          actions: [
            {
              label: "OK",
              callback: () => {
                const switchLids = document.getElementById("lids-switch");
                if (switchLids) {
                  switchLids.checked = false;
                  this.eventHub.emit("lids-switch", { enabled: false });
                }
              },
            },
          ],
        });

        return;
      }
    }
  }
}

export default MakeLids;
